// ApexCharts mide el ancho de su contenedor una sola vez al montarse y solo
// vuelve a redibujarse cuando el navegador dispara un evento nativo
// "window resize". Su propia lógica interna de "redrawOnParentResize" ignora
// el primer cambio de tamaño que reporta el ResizeObserver, así que si el
// grid/layout que envuelve la gráfica termina de acomodarse (sidebar
// colapsado/expandido, contenido asíncrono de tarjetas vecinas, etc.) justo
// después del montaje, esa primera y única variación de tamaño se pierde y
// la gráfica queda renderizada con el ancho equivocado (barras/etiquetas
// comprimidas o superpuestas).
//
// Este mixin observa el tamaño real del contenedor de la gráfica y, cuando
// detecta un cambio genuino de ancho, dispara un evento "resize" real sobre
// window, que ApexCharts sí procesa siempre (no está condicionado a que la
// animación de entrada ya haya terminado).
export default {
  mounted() {
    this._apexResizeFixLastWidth = null;

    if (typeof ResizeObserver === "undefined") {
      return;
    }

    this._apexResizeFixObserver = new ResizeObserver((entries) => {
      const width = entries[0] && entries[0].contentRect.width;
      if (!width) {
        return;
      }

      if (this._apexResizeFixLastWidth === null) {
        this._apexResizeFixLastWidth = width;
        return;
      }

      if (Math.abs(width - this._apexResizeFixLastWidth) > 1) {
        this._apexResizeFixLastWidth = width;
        window.dispatchEvent(new Event("resize"));
      }
    });

    this._apexResizeFixObserver.observe(this.$el);
  },
  beforeDestroy() {
    if (this._apexResizeFixObserver) {
      this._apexResizeFixObserver.disconnect();
      this._apexResizeFixObserver = null;
    }
  },
};
